import React from 'react'
import SidebarTemplate from 'components/templates/SidebarTemplate';
import AttendApplicationApproval from 'components/organismos/master/attend/AttendApplicationApproval';

const AttendApplicationApprovalPage = () => {
  return(
    <SidebarTemplate >
      <AttendApplicationApproval/>
    </SidebarTemplate>
  )
}

export default AttendApplicationApprovalPage